import React from 'react';
import { Box, Skeleton, Divider } from '@mui/material';

/**
 * Skeleton loader component for events list rows
 * Displays shimmer effect while events are loading
 */
const EventsSkeleton = ({ pageLimit = 10 }) => {
  return (
    <Box>
      {[...Array(pageLimit)].map((_, index) => (
        <React.Fragment key={index}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 1.5,
              py: 1.25,
              borderRadius: '6px',
            }}
          >
            {/* Left section: Status badge and event name */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
              <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: '12px', mr: 1 }} />
              <Skeleton variant="text" width={200} height={20} />
            </Box>

            {/* Right section: Time */}
            <Box sx={{ ml: 1.5 }}>
              <Skeleton variant="text" width={80} height={16} />
            </Box>
          </Box>
          {index < pageLimit - 1 && <Divider />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default EventsSkeleton;
